export const esp = {

  dashboard: "Panel",

  accountsReceivable: "Ctas por Cobrar",
  customer: "Cliente",
  inventory: "Inventario",
  product: "Producto",
  presentation: "Presentación",

  
  invoice: "Factura",
  quote: "Pedidos",
  payment: "Pago",
  employee: "Empleado",
  admin: "admin",
  generalSettings: "Configuración General",
  paymentMode: "Tipo de Pago",
  paymentInvoice: "Pago",
  role: "Role",
  settings: "Ajustes",



  generalSettingsAi: "Inteliegencia Artificial",
  settingsAi1: "Asistente",
  settingsAi2: "Asistente",

  //Customers...

  "customerForm": {
    "header": {
      "ADD_NEW_ENTITY": 'Agregar nuevo cliente',
      "DATATABLE_TITLE": 'Lista de clientes',
      "ENTITY_NAME": 'cliente',
      "CREATE_ENTITY": 'Crear cliente',
      "UPDATE_ENTITY": 'Actualizar cliente',
      "PANEL_TITLE": 'Panel de clientes',

    },
    "body": {
      codeClient: "Código",
      businessName: "Razón social",
      comercialDesignation: "Denominación Comercial",
      name: "Nombres",
      surName: "Apellidos",
      email: "Correo Electrónico",
      phone: "Télefono",
      address:"Dirección"

    },
    "requiredMessages": {
      "name": "¡Por favor escriba su nombre !",
      "surName": "¡Por favor escriba su apellido! ",
      "email": "¡Por favor escribe tu correo electrónico!",
      "phone": "¡Por favor escriba su número de teléfono!",
      "message": "Please let us know how can we help you.",
      "country": "Please select a country."
    },
    "invalidMessages": {
      "email": "¡La dirección de correo electrónico es inválida!"
    },
  },
  "presentationForm": {
    "header": {
      "ADD_NEW_ENTITY": 'Agregar nueva presentaccion',
      "DATATABLE_TITLE": 'Lista de clientes',
      "ENTITY_NAME": 'cliente',
      "CREATE_ENTITY": 'Crear cliente',
      "UPDATE_ENTITY": 'Actualizar cliente',
      "PANEL_TITLE": 'Panel de clientes',

    },
    "body": {
      codeClient: "Código",
      businessName: "Razón social",
      comercialDesignation: "Denominación Comercial",
      name: "Nombres",
      surName: "Apellidos",
      email: "Correo Electrónico",
      phone: "Télefono",
      address:"Dirección"

    },
    "requiredMessages": {
      "name": "¡Por favor escriba su nombre !",
      "surName": "¡Por favor escriba su apellido! ",
      "email": "¡Por favor escribe tu correo electrónico!",
      "phone": "¡Por favor escriba su número de teléfono!",
      "message": "Please let us know how can we help you.",
      "country": "Please select a country."
    },
    "invalidMessages": {
      "email": "¡La dirección de correo electrónico es inválida!"
    },
  }

  // Inventory 

}